$(document).on('click', '.bn_feedback__faq-item-body', function () {
    let that = $(this),
        container = that.parents('.bn_feedback__faq-item'),
        content = container.find('.bn_feedback__faq-item-content');

    if (container.hasClass('active')) {
        $('.bn_feedback__faq-item-content').stop().slideUp();

        $('.bn_feedback__faq-item').removeClass('active');

        $('.bn_feedback__faq-item-content-question-content').stop().slideUp();

        $('.bn_feedback__faq-item-content-question').removeClass('active');
    } else  {
        $('.bn_feedback__faq-item-content').stop().slideUp();

        $('.bn_feedback__faq-item').removeClass('active');

        $('.bn_feedback__faq-item-content-question-content').stop().slideUp();

        $('.bn_feedback__faq-item-content-question').removeClass('active');

        container.addClass('active');

        content.stop().slideDown();
    }
});

$(document).on('click', '.bn_feedback__faq-item-content-question-heading', function () {
    let that = $(this),
        wrapper = that.parents('.bn_feedback__faq-wrapper'),
        container = that.parents('.bn_feedback__faq-item-content-question'),
        content = container.find('.bn_feedback__faq-item-content-question-content');

    if (container.hasClass('active')) {
        $('.bn_feedback__faq-item-content-question-content').stop().slideUp();

        $('.bn_feedback__faq-item-content-question').removeClass('active');
    } else  {
        $('.bn_feedback__faq-item-content-question-content').stop().slideUp();

        $('.bn_feedback__faq-item-content-question').removeClass('active');

        container.addClass('active');

        content.stop().slideDown();
    }

    if (!container.attr('data-sent')) {
        $.ajax({
            type: 'post',
            data: {
                id: container.data('id')
            },
            url: wrapper.data('url')
        });
    }

    container.attr('data-sent', true);
});